  <div class="common-style manage-incident-dialog position-relative" appStatusDrawerQuillKeyboard>
  <div class="panel-header d-flex align-items-center justify-content-between">
    <div class="panel-header-spacer"></div>
    <div class="panel-title-block flex-grow-1 text-center">
      <div class="panel-title-row justify-content-center">
        <h6 class="panel-title mb-0">
          {{ incident?.title }}
        </h6>
        <div class="badge-container ms-2">
          <div class="incident-status-pill" [ngClass]="getStatusClass(incident?.status)">
            <span class="status-dot"></span>
            <span class="pill-text">{{ getIncidentStatusLabel(incident?.status) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-actions d-flex align-items-center">
      <button type="button" mat-icon-button class="panel-close-btn" (click)="onCancel()" matTooltip="Close">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-body form common-style mt-2 mb-2 flex-grow-1">
    <div class="incident-manage-container pt-0">

      @if (showPostmortemTab) {
        <div class="manage-tab-row">
          <button type="button" class="manage-tab-btn" [class.active]="activeTab === 'updates'"
          (click)="switchTab('updates')">Updates</button>
          <button type="button" class="manage-tab-btn" [class.active]="activeTab === 'postmortem'"
          (click)="switchTab('postmortem')">Post-Mortem</button>
        </div>
      }

      @if (!showPostmortemTab || activeTab === 'updates') {
        <div class="update-history-section">
          <span class="title-name mb-3 d-block"><strong>UPDATE HISTORY</strong></span>

          <div class="timeline">
            @if (isLoading) {
              @for (i of [1,2,3]; track i) {
                <div class="timeline-item skeleton">
                  <div class="timeline-dot"></div>
                  <div class="timeline-header">
                    <div class="skeleton-line w-30"></div>
                    <div class="skeleton-line w-40 ms-2"></div>
                  </div>
                  <div class="timeline-content">
                    <div class="skeleton-line w-100 mb-2"></div>
                    <div class="skeleton-line w-85"></div>
                  </div>
                </div>
              }
            } @else {
              @for (update of incidentUpdates; track update.incidentUpdateId || $index) {
                <div class="timeline-item" [ngClass]="getTimelineStatusClass(update)">
                  <div class="timeline-dot" [ngClass]="getTimelineStatusClass(update)"></div>

                  <div class="timeline-header">
                    <span class="timeline-status" [ngClass]="getTimelineStatusClass(update)">
                      {{ getTimelineStatusLabel(update) }}
                    </span>
                    <span class="timeline-time">
                      {{ getTimelineDateTimeLabel(update.timestamp) }}
                      @if (showTimezoneForDate(update.timestamp)) {
                      {{ timezoneAbbrev }}
                      }
                    </span>

                    @if (!isUpdateHistoryReadonly && editingUpdateId !== update.incidentUpdateId) {
                      <button type="button" mat-icon-button class="timeline-edit-btn" (click)="startEditUpdate(update)" matTooltip="Edit Update">
                        <mat-icon class="blu-icon material-symbols-outlined">edit</mat-icon>
                      </button>
                    } @else if (!isUpdateHistoryReadonly) {
                      <button class="bg-red align-done-clear-button ms-auto" mat-icon-button type="button" color="warn" (click)="cancelEditUpdate()" matTooltip="Cancel">
                        <mat-icon>clear</mat-icon>
                      </button>
                      <button class="bg-green align-done-clear-button ms-1" mat-icon-button type="button" color="#3699ff" (click)="saveEditUpdate(update)"
                        [disabled]="!editUpdateMessage || editUpdateMessage === originalEditMessage" matTooltip="Save Update">
                        <mat-icon>done</mat-icon>
                      </button>
                    }
                  </div>

                  <div class="timeline-content">
                    @if (!isUpdateHistoryReadonly && editingUpdateId === update.incidentUpdateId) {
                      <div class="inline-editor">
                        <div class="messagefield">
                          <quill-editor [(ngModel)]="editUpdateMessage" [modules]="messageEditorModules" theme="snow" (onContentChanged)="onContentChanged($event)"></quill-editor>
                        </div>
                      </div>
                    } @else {
                      <div [innerHTML]="update.message | statusPageRichText"></div>
                    }
                  </div>
                </div>
                } @empty {
                <div class="title-name">No updates yet.</div>
              }
            }
          </div>
        </div>

        @if (!hidePostUpdateSection) {
        <form id="manageIncidentUpdateForm" class="post-update-section" [formGroup]="updateForm" (ngSubmit)="onPostUpdate()">
          <span class="title-name mb-3 d-block "><strong>+ POST NEW UPDATE</strong></span>

          <div class="col-sm-12 mb-3">
            <span class="title-name">
              Status
              @if (!statusReadonly) {
              <span class="mandatory-star">*</span>
              }
            </span>
            <div class="error-input-wrapper">
              @if (statusReadonly) {
              <span class="incident-status-pill" [ngClass]="getStatusClass(incident?.status)">
                <span class="status-dot"></span>
                <span class="pill-text">{{ getIncidentStatusLabel(incident?.status) }}</span>
              </span>
              } @else {
              <app-custom-select label="Status" [items]="incidentStatusOptions" formControlName="status"
                bindLabel="label" bindValue="value">
              </app-custom-select>
              }
              @if (updateForm.get('status')?.invalid && updateForm.get('status')?.touched) {
                <mat-error>
                  Status is required
                </mat-error>
              }
            </div>
          </div>

          <div class="col-sm-12 mb-3">
            <span class="title-name">Message <span class="mandatory-star">*</span>
            @if (messageLength !== null) {
              <span class="ms-3">({{messageLength}} Char)</span>
            }
          </span>
          <div class="error-input-wrapper">
            <quill-editor class="d-flex flex-column messagefield"
              [placeholder]="'Describe the current status and any actions taken...'"
              [modules]="messageEditorModules"
              formControlName="message" theme="snow" (onContentChanged)="onContentChanged($event)">
            </quill-editor>
            @if (updateForm.get('message')?.hasError('required') && updateForm.get('message')?.touched) {
              <mat-error>
                Message is required
              </mat-error>
            }
            @if ((updateForm.get('message')?.hasError('pattern') || updateForm.get('message')?.hasError('invalidDescription')) && updateForm.get('message')?.touched) {
              <mat-error>
                Message is invalid
              </mat-error>
            }
            @if (updateForm.get('message')?.hasError('maxTextLength') && updateForm.get('message')?.touched) {
              <mat-error>
              Message must be 5000 characters or fewer
            </mat-error>
          }
          </div>
        </div>

        <div class="col-sm-12 mt-4">
          <div class="notify-card">
            <div class="notify-copy">
              <div class="notify-title fw-bold">Send Notifications</div>
              <div class="notify-subtitle">Notify subscribers about this incident</div>
            </div>
            <mat-slide-toggle color="primary" formControlName="notifySubscribers"
              (keydown.enter)="onBooleanControlEnter($event, 'notifySubscribers')"></mat-slide-toggle>
          </div>
        </div>
      </form>
      }
    }

    @if (showPostmortemTab && activeTab === 'postmortem') {
      <app-incident-postmortem
        [incidentId]="incidentId"
        [hasPostmortem]="incidentHasPostmortem"
        (stateChange)="triggerChangeDetection()"
        (postmortemSaved)="onPostmortemSaved()">
      </app-incident-postmortem>
    }
  </div>
</div>

<div class="modal-action p-4">
  <button type="button" class="bt-border" mat-raised-button (click)="onCancel()" [disabled]="isSaving || isPostmortemSaving">Close</button>
  @if (showPostmortemTab && activeTab === 'postmortem') {
    @if (hasPostmortem) {
      <button type="button" class="bt-border text-danger ms-3" mat-raised-button (click)="onDeletePostmortem()"
      [disabled]="isPostmortemSaving || isSaving">Delete Post-Mortem</button>
    }
    <button type="button" class="bt-background ms-5" mat-raised-button
    (click)="onSavePostmortem()" [disabled]="isPostmortemSaving || isSaving || !canSavePostmortem">Save Post-Mortem</button>
  } @else if (!hidePostUpdateSection) {
    <button type="submit" class="bt-background ms-5" mat-raised-button
    [disabled]="updateForm.invalid || isSaving" form="manageIncidentUpdateForm">Post Update</button>
  }
</div>

<!-- Spinner Overlay -->
@if (isSaving || isPostmortemSaving || isPostmortemLoading) {
  <div class="drawer-spinner-overlay">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
}
</div>
